import $ from 'jquery';

class MaRSMagazine {
  constructor() {
    setTimeout(this.LoadActiveResults(), 750);
    setTimeout(this.LoadMagazineIssuesResults(), 750);
    this.resultsDiv = $('.magazineBlock__results');
    this.resultsIssuesDiv = $('.magazineBlock__issueResults');
    this.resultsVideoDiv = $('.magazineBlock__videos');
    this.showButton = $('.magazineBlock__link');
    this.loadMoreButton = $('.magazineBlock__load a');
    this.loadMoreButtonVideo = $('.magazineBlock__loadVideo a');
    this.postsPerPage = 8;
    this.screenWidth = $(window).width();
    this.events();
    this.isSpinnerVisible = false;
    this.previousValue;
    this.typingTimer;
    this.loadInfo;
    this.body = $('body');
    this.selectedFilters = [];
  }

  events() {
    let vm = this;
    this.loadMoreButton.on('click', this.getMoreResults.bind(this));
    this.loadMoreButtonVideo.on('click', this.getMoreResultsVideo.bind(this));
    $('.magazineBlock__newsFilters button').on('click', function () {
      vm.selectedFilters = [];
      $('input[name=news-filter]:checked').each(function () {
        $(this).prop('checked', false);
      });
      vm.LoadFilteredResults(vm.selectedFilters);
    });

    if ($('input[name=news-filter]').length > 0) {
      $('input[name=news-filter]').on('change', function () {
        vm.selectedFilters = []; // reset selectedFilters
        $('input[name=news-filter]:checked').each(function () {
          vm.selectedFilters.push($(this).val());
        });
        setTimeout(() => {
          //debouncer to prevent multiple calls
          vm.LoadFilteredResults(vm.selectedFilters);
        }, 500);
      });
    }
  }

  LoadFilteredResults(filters = []) {
    $('.magazineBlock__results').html(''); //clear the results
    this.LoadActiveResults();
  }

  // getResults() {
  //   if ($('.magazineBlock__results').length) {
  //     $.getJSON(
  //       MaRS_DATA.site_url +
  //         '/wp-json/mars/v1/magazines?term=' +
  //         this.searchField.val() +
  //         '&page=1',
  //       (results) => {
  //         let currentPage = results.current_page;
  //         this.resultsDiv.html(`
  //           ${
  //             results.magazineInfo.length
  //               ? '<div class="row magazineBlock__row events__boxes">'
  //               : '<p>No Magazine information found.</p>'
  //           }
  //             ${results.magazineInfo
  //               .map(
  //                 (
  //                   item
  //                 ) => `<div class="col-12 col-md-4 col-sm-4 magazineBlock__event">
  //               <div class="magazineBlock__event">
  //                 ${
  //                   item.add_event_cta === true
  //                     ? `
  //                 <a href="${item.event_cta_link}" alt="${item.title}" aria-label="${item.title}">
  //                   <div class="magazineBlock__event-cta">
  //                     ${item.event_cta_content}
  //                     <i class="event__arrow"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
  //                     <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
  //                         <path d="M1 5h42M40 1l4 4-4 4"/></g></svg></i>
  //                   </div>
  //                 </a>`
  //                     : `<a href="${
  //                         item.external_link
  //                           ? item.external_link
  //                           : item.permalink
  //                       }" ${
  //                         item.external_link ? `target="_blank"` : ``
  //                       } alt="${item.title}" aria-label="${item.title}">

  //                   <div class="magazineBlock__event-featuredImg" style="background:url(${
  //                     item.event_image
  //                   }) no-repeat;"></div>
  //                   <div class="magazineBlock__event-contentWrapper">
  //                       <p class="magazineBlock__event-sponsor">${
  //                         item.sponsor
  //                       }</p>
  //                       <p class="bold">${item.title}</p>
  //                       <ul>
  //                           <li class="marsCal__icon"><span>${
  //                             item.start_date
  //                           }</span></li>
  //                           ${
  //                             item.start_time
  //                               ? `<li class="marsClock__icon"><span>${
  //                                   item.start_time
  //                                 } ${
  //                                   item.end_time ? ` - ${item.end_time}` : ``
  //                                 }</span></li>`
  //                               : ''
  //                           }
  //                           <li class="marsPin__icon"><span>${
  //                             item.location
  //                           }</span></li>
  //                       </ul>
  //                   </div>
  //                 </a>`
  //                 }
  //           </div></div>`
  //               )
  //               .join('')}
  //         ${results.magazineInfo.length ? '</div>' : ''}
  //     `);
  //         this.isSpinnerVisible = false;
  //         this.searchField.val()
  //           ? this.loadMoreButton.attr(
  //               'data-url',
  //               `term=${this.searchField.val()}&page=2`
  //             )
  //           : '';
  //         `${
  //           results.max_pages == currentPage
  //             ? this.loadMoreButton.hide()
  //             : this.loadMoreButton.show()
  //         }`;
  //       }
  //     ).fail(function (jqXHR, textStatus, error) {});
  //   }
  // }

  LoadActiveResults() {
    let vm = this;

    if (!vm.isSpinnerVisible) {
      $('.magazineBlock__results').prepend(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
      vm.isSpinnerVisible = true;
    }

    if ($('.magazineBlock__results').length) {
      $.when(
        $.getJSON(
          MaRS_DATA.site_url +
            '/wp-json/mars/v1/magazines?term=&page=1' +
            (vm.selectedFilters && vm.selectedFilters.length > 0
              ? `&newsFilter=${vm.selectedFilters.join(',')}`
              : '')
        ),
        $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/videos?term=&page=1')
      ).then((results, videos) => {
        let currentPage = results[0].current_page;
        this.resultsDiv.html(`
            ${
              results[0].magazineInfo.length
                ? '<div class="row no-gutters magazineBlock__row">'
                : '<p>No Magazine information found.</p>'
            }
              ${results[0].magazineInfo
                .map(
                  (item) => `<div class="col-12 col-md-12 magazineBlock__card ${
                    item.magazine_featured === true
                      ? 'magazineBlock__featured'
                      : 'magazineBlock__default'
                  }">
                <div class="magazineBlock__wrap">       
                  ${
                    item.magazine_featured === true
                      ? `
                  <div style="background: url('${
                    item.magazine_image
                  }') no-repeat">
                    <div class="magazineBlock__mask"></div>
                    <div class="magazineBlock__contentWrapper">
                      <a class="magazineBlock__category"
                      href="${
                        item.postType === 'magazine'
                          ? item.primary_category_link
                            ? item.primary_category_link
                            : item.magazine_issue_link
                          : item.primary_category_link
                          ? item.primary_category_link
                          : item.news_series_link
                      }" 
                      tabindex="0" 
                      title="${
                        item.magazine_issue || item.news_series
                          ? item.primary_category
                            ? `${item.primary_category}`
                            : item.postType === 'magazine'
                            ? `${item.magazine_issue}`
                            : `${item.news_series}`
                          : ''
                      }">
                      ${
                        item.magazine_issue || item.news_series
                          ? item.primary_category
                            ? `${item.primary_category}`
                            : item.postType === 'magazine'
                            ? `${item.magazine_issue}`
                            : `${item.news_series}`
                          : ''
                      }</a>
                      <h2><a href="${item.permalink}" tabindex="0">${
                          item.title
                        }</a></h2>
                    </div>
                    <svg class="magazineIssues__arrow" role="presentation" xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                      <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                        <path d="M1 5h42M40 1l4 4-4 4"/>
                      </g>
                    </svg>
                  </div>`
                      : `<div>
                      <div class="magazineBlock__contentWrapper">
                        <div class="row no-gutters">
                          <div class="col-12 col-sm-4 magazineBlock__postImage" style="background: url('${
                            item.magazine_image
                          }') no-repeat" role="img" aria-label="${
                          item.title
                        } featured image">
                            <a href="${item.permalink}" aria-label="${
                          item.title
                        }" tabindex="0">
                              <div class="magazineBlock__mask"></div>
                              <svg class="magazineIssues__arrow" role="presentation" xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                                <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                                  <path d="M1 5h42M40 1l4 4-4 4"/>
                                </g>
                              </svg>
                            </a>
                          </div>
                          <div class="col-12 col-sm-1"></div>
                          <div class="col-12 col-sm-7">
                            <a class="magazineBlock__category d-inline" tabindex="0"
                            title="${
                              item.magazine_issue || item.news_series
                                ? item.primary_category
                                  ? `${item.primary_category}`
                                  : item.postType === 'magazine'
                                  ? `${item.magazine_issue}`
                                  : `${item.news_series}`
                                : ''
                            }"
                            href="${
                              item.postType === 'magazine'
                                ? item.primary_category_link
                                  ? item.primary_category_link
                                  : item.magazine_issue_link
                                : item.primary_category_link
                                ? item.primary_category_link
                                : item.news_series_link
                            }"
                            >${
                              item.magazine_issue || item.news_series
                                ? item.primary_category
                                  ? `${item.primary_category}`
                                  : item.postType === 'magazine'
                                  ? `${item.magazine_issue}`
                                  : `${item.news_series}`
                                : ''
                            }</a>
                            <a href="${item.permalink}" tabindex="0" title="${
                          item.title
                        }">
                              <h3 class="bold">${item.title}</h3>
                              <p>${
                                item.magazine_sub_heading
                                  ? `${item.magazine_sub_heading}`
                                  : `${
                                      item.short_description
                                        ? item.short_description
                                        : item.description
                                    }`
                              }</p>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>`
                  }    
                </div></div>`
                )
                .join('')}
                ${results[0].magazineInfo.length ? '</div>' : ''}
          `);
        $('.sk-double-bounce').remove();
        this.isSpinnerVisible = false;

        /* Load Videos */
        this.resultsVideoDiv.html(`
            ${
              videos[0].videoInfo.length
                ? '<div class="row no-gutters magazineBlock__row">'
                : '<p>No Videos found.</p>'
            }
              ${videos[0].videoInfo
                .map(
                  (
                    item
                  ) => `<div class="col-12 col-md-12 magazineBlock__VideoCard">
                <div class="magazineBlock__wrap">
                  <a href="${item.permalink}" tabindex="0">
                    <div class="magazineBlock__VideoMask"></div>
                    <div class="magazineBlock__videoImage" style="background: url('${item.video_image}') no-repeat;" role="image" aria-label="${item.title} featured image">
                      <span class="magazineBlock__vidButton"></span>
                    </div>
                    <h4 class="subtitle">${item.title}</h4>
                  </a>
                </div></div>`
                )
                .join('')}
              ${videos[0].videoInfo.length ? '</div>' : ''}
          `);
        this.isSpinnerVisible = false;
        this.loadMoreButton.attr(
          'data-url',
          `term=&page=${parseInt(currentPage) + 1}`
        );
        this.loadMoreButtonVideo.attr(
          'data-url',
          `term=&page=${parseInt(currentPage) + 1}`
        );
        `${
          results[0].max_pages == currentPage
            ? this.loadMoreButton.hide()
            : this.loadMoreButton.show()
        }`;
      });
    }
  }

  LoadMagazineIssuesResults() {
    if ($('.magazineBlock__issueResults').length) {
      let taxname = $('.magazineBlock__issueResults').attr('data-tax-id');
      $.when(
        $.getJSON(
          MaRS_DATA.site_url +
            '/wp-json/mars/v1/magazines?issue=' +
            taxname +
            '&page=1'
        ),
        $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/videos?term=&page=1')
      ).then((results, videos) => {
        let currentPage = results[0].current_page;
        this.resultsIssuesDiv.html(`
            ${
              results[0].magazineInfo.length
                ? '<div class="row no-gutters magazineBlock__row">'
                : '<p>No Magazine information found.</p>'
            }
              ${results[0].magazineInfo
                .map(
                  (item) => `<div class="col-12 col-md-12 magazineBlock__card ${
                    item.magazine_featured === true
                      ? 'magazineBlock__featured'
                      : 'magazineBlock__default'
                  }">
                <div class="magazineBlock__wrap">
                  ${
                    item.magazine_featured === true
                      ? `
                  <div style="background: url('${
                    item.magazine_image
                  }') no-repeat">
                    <div class="magazineBlock__mask"></div>
                    <div class="magazineBlock__contentWrapper">
                      <a class="magazineBlock__category"
                      title="${
                        item.magazine_issue || item.news_series
                          ? item.primary_category
                            ? `${item.primary_category}`
                            : item.postType === 'magazine'
                            ? `${item.magazine_issue}`
                            : `${item.news_series}`
                          : ''
                      }"
                      href="${
                        item.postType === 'magazine'
                          ? item.primary_category_link
                            ? item.primary_category_link
                            : item.magazine_issue_link
                          : item.primary_category_link
                          ? item.primary_category_link
                          : item.news_series_link
                      }" 
                      tabindex="0">${
                        item.magazine_issue || item.news_series
                          ? item.primary_category
                            ? `${item.primary_category}`
                            : item.postType === 'magazine'
                            ? `${item.magazine_issue}`
                            : `${item.news_series}`
                          : ''
                      }</a>
                      <h2><a href="${item.permalink}" tabindex="0">${
                          item.title
                        }</a></h2>
                    </div>
                    <svg class="magazineIssues__arrow" role="presentation" xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                    <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                      <path d="M1 5h42M40 1l4 4-4 4"/>
                    </g></svg>
                  </div>`
                      : `<div>
                    <div class="magazineBlock__contentWrapper">
                      <div class="row no-gutters">
                        <div class="col-12 col-sm-4 magazineBlock__postImage" style="background: url('${
                          item.magazine_image
                        }') no-repeat" role="img" aria-label="${
                          item.title
                        } featured image">
                          <a href="${item.permalink}" aria-label="${
                          item.title
                        }" tabindex="0">
                            <div class="magazineBlock__mask"></div>
                            <svg class="magazineIssues__arrow" role="presentation" xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                              <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                                <path d="M1 5h42M40 1l4 4-4 4"/>
                              </g>
                            </svg>
                          </a>
                        </div>
                        <div class="col-12 col-sm-1"></div>
                        <div class="col-12 col-sm-7">
                          <a class="magazineBlock__category d-inline"
                          title="${
                            item.magazine_issue || item.news_series
                              ? item.primary_category
                                ? `${item.primary_category}`
                                : item.postType === 'magazine'
                                ? `${item.magazine_issue}`
                                : `${item.news_series}`
                              : ''
                          }"
                          href="${
                            item.postType === 'magazine'
                              ? item.primary_category_link
                                ? item.primary_category_link
                                : item.magazine_issue_link
                              : item.primary_category_link
                              ? item.primary_category_link
                              : item.news_series_link
                          }" 
                          tabindex="0">${
                            item.magazine_issue || item.news_series
                              ? item.primary_category
                                ? `${item.primary_category}`
                                : item.postType === 'magazine'
                                ? `${item.magazine_issue}`
                                : `${item.news_series}`
                              : ''
                          }</a>
                          <a href="${item.permalink}" title="${
                          item.title
                        }" tabindex="0">
                            <h3 class="bold">${item.title}</h3>
                            <p>${
                              item.magazine_sub_heading
                                ? `${item.magazine_sub_heading}`
                                : `${
                                    item.short_description
                                      ? item.short_description
                                      : item.description
                                  }`
                            }</p>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>`
                  }
                </div></div>`
                )
                .join('')}
              ${results[0].magazineInfo.length ? '</div>' : ''}
          `);

        /* Load Videos */
        this.resultsVideoDiv.html(`
              ${
                videos[0].videoInfo.length
                  ? '<div class="row no-gutters magazineBlock__row">'
                  : '<p>No Videos found.</p>'
              }
                ${videos[0].videoInfo
                  .map(
                    (
                      item
                    ) => `<div class="col-12 col-md-12 magazineBlock__VideoCard">
                  <div class="magazineBlock__wrap">
                    <a href="${item.permalink}" tabindex="0" title="${item.title}">
                      <div class="magazineBlock__VideoMask"></div>
                      <div class="magazineBlock__videoImage" style="background: url('${item.video_image}') no-repeat;" role="image" aria-label="${item.title} featured image">
                        <span class="magazineBlock__vidButton"></span>
                      </div>
                      <h4 class="subtitle">${item.title}</h4>
                    </a>
                </div></div>`
                  )
                  .join('')}
              ${videos[0].videoInfo.length ? '</div>' : ''}
          `);
        this.isSpinnerVisible = false;

        //`${results[0].magazineInfo.length == this.postsPerPage ? this.loadMoreButton.show() : this.loadMoreButton.hide()}`;
        this.loadMoreButton.attr(
          'data-url',
          `issue=${taxname}&page=${parseInt(currentPage) + 1}`
        );
        `${
          results[0].max_pages == currentPage
            ? this.loadMoreButton.hide()
            : this.loadMoreButton.show()
        }`;
      });
    }
  }

  getMoreResults(e) {
    e.preventDefault();
    this.loadInfo = this.loadMoreButton.attr('data-url');
    let vm = this;
    if (!this.isSpinnerVisible) {
      this.resultsDiv.append(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
      this.isSpinnerVisible = true;
    }
    let taxname = $('.magazineBlock__issueResults').attr('data-tax-id');
    $.when(
      $.getJSON(
        MaRS_DATA.site_url +
          '/wp-json/mars/v1/magazines?' +
          this.loadInfo +
          (vm.selectedFilters && vm.selectedFilters.length > 0
            ? `&newsFilter=${vm.selectedFilters.join(',')}`
            : '')
      ),
      $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/videos?' + this.loadInfo)
    )
      .then((results, videos) => {
        let currentPage = results[0].current_page;
        if (!taxname) {
          this.resultsDiv.append(`
          ${
            results[0].magazineInfo.length
              ? '<div class="row no-gutters magazineBlock__row">'
              : '<p>No Magazine information found.</p>'
          }
            ${results[0].magazineInfo
              .map(
                (item) => `<div class="col-12 col-md-12 magazineBlock__card ${
                  item.magazine_featured === true
                    ? 'magazineBlock__featured'
                    : 'magazineBlock__default'
                }">
              <div class="magazineBlock__wrap">
                ${
                  item.magazine_featured === true
                    ? `
                <div style="background: url('${
                  item.magazine_image
                }') no-repeat">
                  <div class="magazineBlock__mask"></div>
                  <div class="magazineBlock__contentWrapper">
                    <a class="magazineBlock__category"
                    title="${item.title}"
                    href="${
                      item.postType === 'magazine'
                        ? item.primary_category_link
                          ? item.primary_category_link
                          : item.magazine_issue_link
                        : item.primary_category_link
                        ? item.primary_category_link
                        : item.news_series_link
                    }" 
                    tabindex="0">${
                      item.magazine_issue || item.news_series
                        ? item.primary_category
                          ? `${item.primary_category}`
                          : item.postType === 'magazine'
                          ? `${item.magazine_issue}`
                          : `${item.news_series}`
                        : ''
                    }</a>
                    <h2><a href="${item.permalink}" title="${
                        item.title
                      }" tabindex="0">${item.title}</a></h2>
                  </div>
                  <svg class="magazineIssues__arrow" role="presentation" xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                      <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                        <path d="M1 5h42M40 1l4 4-4 4"/>
                    </g></svg>
                </div>`
                    : `<div>
                  <div class="magazineBlock__contentWrapper">
                    <div class="row no-gutters">
                      <div class="col-12 col-sm-4 magazineBlock__postImage" style="background: url('${
                        item.magazine_image
                      }') no-repeat" role="img" aria-label="${
                        item.title
                      } featured image">
                        <a href="${item.permalink}" aria-label="${
                        item.title
                      }" tabindex="0">
                          <div class="magazineBlock__mask"></div>
                          <svg class="magazineIssues__arrow" role="presentation" xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                            <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                              <path d="M1 5h42M40 1l4 4-4 4"/>
                            </g>
                          </svg>
                        </a>
                      </div>
                      <div class="col-12 col-sm-1"></div>
                      <div class="col-12 col-sm-7">
                        <a class="magazineBlock__category d-inline"
                        title="${item.title}"
                        href="${
                          item.postType === 'magazine'
                            ? item.primary_category_link
                              ? item.primary_category_link
                              : item.magazine_issue_link
                            : item.primary_category_link
                            ? item.primary_category_link
                            : item.news_series_link
                        }" 
                        tabindex="0">${
                          item.magazine_issue || item.news_series
                            ? item.primary_category
                              ? `${item.primary_category}`
                              : item.postType === 'magazine'
                              ? `${item.magazine_issue}`
                              : `${item.news_series}`
                            : ''
                        }</a>
                        <a href="${item.permalink}" tabindex="0" title="${
                        item.title
                      }">
                          <h3 class="bold">${item.title}</h3>
                          <p>${
                            item.magazine_sub_heading
                              ? `${item.magazine_sub_heading}`
                              : `${
                                  item.short_description
                                    ? item.short_description
                                    : item.description
                                }`
                          }</p>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>`
                }
              </div></div>`
              )
              .join('')}
            ${results[0].magazineInfo.length ? '</div>' : ''}
        `);
        } else {
          this.resultsIssuesDiv.append(`
            ${
              results[0].magazineInfo.length
                ? '<div class="row no-gutters magazineBlock__row">'
                : '<p>No Magazine information found.</p>'
            }
              ${results[0].magazineInfo
                .map(
                  (item) => `<div class="col-12 col-md-12 magazineBlock__card ${
                    item.magazine_featured === true
                      ? 'magazineBlock__featured'
                      : 'magazineBlock__default'
                  }">
                <div class="magazineBlock__wrap">
                  ${
                    item.magazine_featured === true
                      ? `
                  <div style="background: url('${
                    item.magazine_image
                  }') no-repeat">
                    <div class="magazineBlock__mask"></div>
                    <div class="magazineBlock__contentWrapper">
                      <a class="magazineBlock__category"
                      title="${item.title}"
                      href="${
                        item.postType === 'magazine'
                          ? item.primary_category_link
                            ? item.primary_category_link
                            : item.magazine_issue_link
                          : item.primary_category_link
                          ? item.primary_category_link
                          : item.news_series_link
                      }" 
                      tabindex="0">${
                        item.magazine_issue || item.news_series
                          ? item.primary_category
                            ? `${item.primary_category}`
                            : item.postType === 'magazine'
                            ? `${item.magazine_issue}`
                            : `${item.news_series}`
                          : ''
                      }</a>
                      <h2><a href="${item.permalink}" tabindex="0">${
                          item.title
                        }</a></h2>
                    </div>
                    <svg class="magazineIssues__arrow" role="presentation" xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                    <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                      <path d="M1 5h42M40 1l4 4-4 4"/>
                    </g></svg>
                  </div>`
                      : `<div>
                      <div class="magazineBlock__contentWrapper">
                        <div class="row no-gutters">
                          <div class="col-12 col-sm-4 magazineBlock__postImage" style="background: url('${
                            item.magazine_image
                          }') no-repeat" role="img" aria-label="${
                          item.title
                        } featured image">
                            <a href="${item.permalink}" aria-label="${
                          item.title
                        }" tabindex="0">
                              <div class="magazineBlock__mask"></div>
                              <svg class="magazineIssues__arrow" role="presentation" xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                                <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                                  <path d="M1 5h42M40 1l4 4-4 4"/>
                                </g>
                              </svg>
                            </a>
                          </div>
                          <div class="col-12 col-sm-1"></div>
                          <div class="col-12 col-sm-7">
                            <a class="magazineBlock__category d-inline"
                            title="${item.title}"
                            href="${
                              item.postType === 'magazine'
                                ? item.primary_category_link
                                  ? item.primary_category_link
                                  : item.magazine_issue_link
                                : item.primary_category_link
                                ? item.primary_category_link
                                : item.news_series_link
                            }" 
                            tabindex="0">${
                              item.magazine_issue || item.news_series
                                ? item.primary_category
                                  ? `${item.primary_category}`
                                  : item.postType === 'magazine'
                                  ? `${item.magazine_issue}`
                                  : `${item.news_series}`
                                : ''
                            }</a>
                            <a href="${item.permalink}" tabindex="0" title="${
                          item.title
                        }">
                              <h3 class="bold">${item.title}</h3>
                              <p>${
                                item.magazine_sub_heading
                                  ? `${item.magazine_sub_heading}`
                                  : `${
                                      item.short_description
                                        ? item.short_description
                                        : item.description
                                    }`
                              }</p>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>`
                  }
                </div></div>`
                )
                .join('')}
            ${results[0].magazineInfo.length ? '</div>' : ''}
        `);
        }

        setTimeout(function () {
          let elmnt = document.querySelectorAll(
            '.magazineBlock__results .magazineBlock__row'
          );
          elmnt = elmnt[elmnt.length - 1];
          let offset = $(elmnt).offset();
          $('html, body').animate({
            scrollTop: offset.top - 70,
            scrollLeft: offset.left,
          });
        }, 500);

        $('.sk-double-bounce').remove();
        this.isSpinnerVisible = false;

        if (taxname) {
          this.loadMoreButton.attr(
            'data-url',
            `issue=${taxname}&page=${parseInt(currentPage) + 1}`
          );
        } else {
          this.loadMoreButton.attr(
            'data-url',
            `term=&page=${parseInt(currentPage) + 1}`
          );
        }
        `${
          results[0].max_pages == currentPage
            ? this.loadMoreButton.hide()
            : this.loadMoreButton.show()
        }`;
      })
      .fail(function (jqXHR, textStatus, error) {});
  }

  getMoreResultsVideo(e) {
    e.preventDefault();
    this.loadInfo = this.loadMoreButtonVideo.attr('data-url');

    if (!this.isSpinnerVisible) {
      this.resultsVideoDiv.append(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
      this.isSpinnerVisible = true;
    }
    $.getJSON(
      MaRS_DATA.site_url + '/wp-json/mars/v1/videos?' + this.loadInfo,
      (videos) => {
        let currentPage = videos.current_page;
        /* Load Videos */
        this.resultsVideoDiv.append(`
        ${
          videos.videoInfo.length
            ? '<div class="row no-gutters magazineBlock__row">'
            : '<p>No Videos found.</p>'
        }
          ${videos.videoInfo
            .map(
              (item) => `<div class="col-12 col-md-12 magazineBlock__VideoCard">
            <div class="magazineBlock__wrap">
              <a href="${item.permalink}" tabindex="0" title="${item.title}">
                <div class="magazineBlock__VideoMask"></div>
                <div class="magazineBlock__videoImage" style="background: url('${item.video_image}') no-repeat" role="image" aria-label="${item.title} featured image">
                  <span class="magazineBlock__vidButton"></span>
                </div>
                <h4 class="subtitle">${item.title}</h4>
              </a>
          </div></div>`
            )
            .join('')}
          ${videos.videoInfo.length ? '</div>' : ''}
        `);

        setTimeout(function () {
          let elmnt = document.querySelectorAll(
            '.magazineBlock__videos .magazineBlock__row'
          );
          elmnt = elmnt[elmnt.length - 1];
          let offset = $(elmnt).offset();
          $('html, body').animate({
            scrollTop: offset.top - 70,
            scrollLeft: offset.left,
          });
        }, 500);

        $('.sk-double-bounce').remove();
        this.isSpinnerVisible = false;
        this.loadMoreButtonVideo.attr(
          'data-url',
          `term=&page=${parseInt(currentPage) + 1}`
        );
        `${
          videos.max_pages === currentPage ||
          videos.max_pages < videos.current_page
            ? this.loadMoreButtonVideo.hide()
            : this.loadMoreButtonVideo.show()
        }`;
      }
    ).fail(function (jqXHR, textStatus, error) {});
  }
}

export default MaRSMagazine;
